import React, { useEffect, useState } from "react";
import SuperAdminLayout from "../../layout/SuperAdminLayout";
import { Button, Table, Tooltip } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import axios from "axios";
import AddCommissaryDrawer from "./AddCommissaryDrawer";
import AdminCommissaryEdit from "./AdminCommissaryEdit";

// const defaultExpandable = {
//   expandedRowRender: (record) => <p>{record.description}</p>,
// };

const SuperadminCommissary = () => {
  const [commissaryList, setCommissaryList] = useState({
    data: [],
    ready: false,
  });
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  // const expandable = defaultExpandable;
  const tableLayout = "";
  const scroll = {};
  const [editDrawer, setEditDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const columns = [
    {
      title: "Business Name",
      dataIndex: "business_name",
      sorter: (a, b) => a.business_name - b.business_name,
    },
    {
      title: "Registered Name",
      dataIndex: "fullname",
      sorter: (a, b) => a.reg_firstname - b.reg_firstname,
    },
    {
      title: "Address",
      dataIndex: "address",
      filters: [
        {
          text: "BUTUAN CITY (Capital)",
          value: "BUTUAN CITY (Capital)",
        },
        {
          text: "CITY OF PANABO",
          value: "CITY OF PANABO",
        },
        {
          text: "CITY OF TAGUM (Capital)",
          value: "CITY OF TAGUM (Capital)",
        },
        {
          text: "DAVAO CITY",
          value: "DAVAO CITY",
        },
      ],
      // onFilter: (value, record) => record.address.indexOf(value) === 0,
      onFilter: (value, record) => record.address.includes(value),
      sorter: (a, b) => a.address.length - b.address.length,
      // sortOrder: sortedInfo.columnKey === 'address' ? sortedInfo.order : null,
      ellipsis: true,
      render: (text, record) => {
        return {
          props: {
            style: { textTransform: "uppercase" },
          },
          children: text,
        };
      },
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEditDrawer(true);
              }}
              icon={<EditOutlined />}
              style={{ marginRight: 10 }}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getCommissaryList = () => {
    axios
      .get("user/admin/commissary-list")
      .then((response) => {
        const data = response.data;
        setCommissaryList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getCommissaryList();
  }, []);

  return (
    <SuperAdminLayout>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }} />
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenDrawer(true)}
        >
          Commissary
        </Button>
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={commissaryList.data.length > 0 ? commissaryList.data : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {openDrawer && (
        <AddCommissaryDrawer
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getCommissaryList={() => getCommissaryList()}
        />
      )}

      {editDrawer && (
        <AdminCommissaryEdit
          open={editDrawer}
          close={() => setEditDrawer(false)}
          setLoading={setLoading}
          getCommissaryList={() => getCommissaryList()}
          selectedData={selectedData}
        />
      )}
    </SuperAdminLayout>
  );
};

export default SuperadminCommissary;
